import {
  Component,
  EventEmitter,
  Output,
  computed,
  input,
} from '@angular/core';
import { IServiceInfoDetail } from 'src/app/models';
import { LiteralService, UtilsService } from 'src/app/services';
import { TooltipPosition } from 'src/app/shared/tooltip/tooltip-position';
import { images } from 'src/images';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-service-row',
  templateUrl: './service-row.component.html',
  standalone: false,
})
export class ServiceRowComponent {
  readonly service = input<IServiceInfoDetail>();
  readonly index = input<number>();
  readonly serviceInfoSelected = input<any>();
  readonly isSelected = computed(() => {
    const serviceInfoSelected = this.serviceInfoSelected();
    return !!serviceInfoSelected && serviceInfoSelected.id === this.service()?.id;
  });
  readonly isOddRow = computed(() => this.index()! % 2 !== 0);
  // @Input() showRoutesService: IServiceInfoDetail;
  @Output() showRoutes = new EventEmitter<any>();
  @Output() showServiceInfoData = new EventEmitter<any>();

  public images = images;
  public TooltipPosition = TooltipPosition;

  constructor(
    public utilsService: UtilsService,
    public literalService: LiteralService,
    private activatedRoute: ActivatedRoute,
  ) {}

  getRouteUrl() {
    const params = this.activatedRoute.snapshot.queryParams;
    const parts: string[] = [];
    for (const [key, value] of Object.entries(params)) {
      if (Array.isArray(value)) {
        value.forEach((v) => parts.push(`${key}=${encodeURIComponent(v)}`));
      } else if (value !== null && value !== undefined) {
        parts.push(`${key}=${encodeURIComponent(value as string)}`);
      }
    }
    const queryParams = parts.length ? `?${parts.join('&')}` : '';
    if (!this.service()) return `/services${queryParams}`;
    return `/services/${this.service()?.id}/routes${queryParams}`;
  }
}
